import { FormControl, FormGroup } from "@angular/forms";

export interface ProductModel {
    productId: number | null;
    ihdid: number | null;
    description: string | null;
    sku: string | null;
    upc: string | null;
    barcode: string | null;
    casepackID: string | null;
    catalogueID: string | null;
    productUnitCode: string | null;
    productUnitName: string | null;
    labelCode: string | null;
    labelName: string | null;
    productCategory: string | null;
    productSubCategory: string | null;
    industry: string | null;
    casePack: number | null;
    casePackStatus: string | null;
    
    // Product Life Cycle
    productStatus: string | null;
    launchDate: Date | null;
    streetDate: Date | null;
    releaseDate: Date | null;
    lifecycleID: string | null;
    productLifeCycle: number | null;
    preAwarenessDate: Date | null;
    shelfLife: number | null;
    discontinuationDate: Date | null;
  
    // Inventory and Stock
    reorderQuantity: number | null;
    maximumOrderQuantity: string | null;
    minimumOrderQuantity: string | null;
    leadTime: number | null;
    maximumInventoryLevel: string | null;
    substituteProducts: string | null;
    inventoryType: number | null;
    diminishing: string | null;
    medium: string | null;
  
    // Pricing Manager
    msrp: number | null;
    wholsalePrice: string | null;
    partnerCost: string | null;
    partnerPrice: string | null;
    retailPrice: string | null;
    discountRate: string | null;
    taxRate: string | null;
  
    // Product Details
    title: string | null;
    vendorProductCode: number | null;
    vendorProductID: number | null;
    artist: string | null;
    comments: string | null;
    season: string | null;
    seasonCode: string | null;
  
    // Supplier Information
    preferredVendor: string | null;
    manufacturerCode: string | null;
    vendorName: string | null;
    manufacturerProductName: string | null;
    manufacturerName: string | null;
  
    // Regulatory and Sales
    expiryDate: Date | null;
    taxExmpt: string | null;
    taxExemptId: string | null;
    orderMultiples: string | null;
  
    // Logistics and Shipping
    replenishmentFrequency: string | null;
    unitOfMeasurement: number | null;
    caseSize: string | null;
    active: boolean | null;
    isOrderable: boolean | null;
    family: string | null;
    [key: string]: any
    
  }
  
  export const DefaultProduct: ProductModel = {
        productId: null,
        ihdid: null,
        description: null,
        sku: null,
        upc: null,
        barcode: null,
        casepackID: null,
        catalogueID: null,
        productUnitCode: null,
        productUnitName: null,
        labelCode: null,
        labelName: null,
        productCategory: null,
        productSubCategory: null,
        industry: null,
        casePack: null,
        casePackStatus: null,
        
        // Product Life Cycle
        productStatus: null,
        launchDate: new Date,
        streetDate: new Date,
        releaseDate: new Date,
        lifecycleID: null,
        productLifeCycle: null,
        preAwarenessDate: new Date,
        shelfLife: null,
        discontinuationDate: new Date,
      
        // Inventory and Stock
        reorderQuantity: null,
        maximumOrderQuantity: null,
        minimumOrderQuantity: null,
        leadTime: null,
        maximumInventoryLevel: null,
        substituteProducts: null,
        inventoryType: null,
        diminishing: null,
        medium: null,
      
        // Pricing Manager
        msrp: null,
        wholsalePrice: null,
        partnerCost: null,
        partnerPrice: null,
        retailPrice: null,
        discountRate: null,
        taxRate: null,
      
        // Product Details
        title: null,
        vendorProductCode: null,
        vendorProductID: null,
        artist: null,
        comments: null,
        season: null,
        seasonCode: null,
      
        // Supplier Information
        preferredVendor: null,
        manufacturerCode: null,
        vendorName: null,
        manufacturerProductName: null,
        manufacturerName: null,
      
        // Regulatory and Sales
        expiryDate: new Date,
        taxExmpt: null,
        taxExemptId: null,
        orderMultiples: null,
      
        // Logistics and Shipping
        replenishmentFrequency: null,
        unitOfMeasurement: null,
        caseSize: null,
        active: false,
        isOrderable: false,
        family: null,

  }

  export type ProductFormGroup = FormGroup<{ [K in keyof ProductModel]: FormControl<ProductModel[K]> }>;